import axios from 'axios';
import RestService from '../../../helpers/RestService';


axios.defaults.headers.common = {
  'Accept': 'application/json, text/plain',
  'X-CSRF-Token': RestService.getCsrfToken(),
  'X-Requested-With' : 'XMLHttpRequest',
};

axios.defaults.headers.post['Content-Type'] = 'application/json';

export async function getUserCountQuestion(body) {
  try {
    const {data} = await axios.post('/api/teacher/statuses', body);
    if(data.errcode == 200) {
      return data.payload;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}


export async function getUserTransaction(body) {
  try {
    const {data} = await axios.post('/api/admin/user-transaction', body);
    if(data.errcode == 200) {
      return data.payload;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}


export async function createUserTransaction(body) {
  try {

    var bodyFormData = new FormData();

    Object.keys(body).forEach(key => {
      if('UploadFiles' == key){
        bodyFormData.append('UploadFiles[file]', body[key])
      } else {
        bodyFormData.append(key, body[key])
      }
    });

    const {data} = await axios.post('/api/admin/new-transaction', bodyFormData);
    if(data.errcode == 200) {
      return data.payload;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}

export async function getUserLastLogin(body) {
  try {
    const {data} = await axios.post('/api/admin/user-last-login', body);
    if(data.errcode == 200) {
      return data.payload;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}

export async function setUserPaidDate(body) {
  try {
    const {data} = await axios.post('/api/admin/user-paid-date', body);
    if(data.errcode == 200) {
      return data.payload;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}

export async function sendConfirm(body) {
  try {
    const {data} = await axios.post('/api/admin/send-confirm-user', body);
    if(data.errcode == 200) {
      return true;
    } else {
      return Promise.reject({message: 'Not send message'})
    }
  } catch (error) {
    return Promise.reject({message: 'Not send message'})
  }
}
export async function sendLoginUser(body) {
  try {
    const {data} = await axios.post('/api/admin/send-login-user', body);
    if(data.errcode == 200) {
      return true;
    } else {
      return Promise.reject({message: 'Not send message'})
    }
  } catch (error) {
    return Promise.reject({message: 'Not send message'})
  }
}

export function updateUser(user) {
  return (dispatch) => {
    dispatch({type: 'UPDATE_USER_LIST', user})
  }
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/AdminPanel/Users/actions.js